type TableCellAlignment = 'left' | 'center' | 'right'

export type TableCellProps = {
  content: string
  applyDefaultStyles?: boolean
  align?: TableCellAlignment
}

export class TableCell {
  content: string
  applyDefaultStyles: boolean
  align: TableCellAlignment

  constructor({ content, applyDefaultStyles = true, align = 'left' }: TableCellProps) {
    this.content = content
    this.applyDefaultStyles = applyDefaultStyles
    this.align = align
  }
}
